import svgPaths from '../../imports/svg-2tmymdn3ip';
import { useLanguage } from '@/contexts/AppContext';
import { loginPageTranslations } from '@/i18n';

interface AuthHeaderProps {
  onBack: () => void;
}

/**
 * 인증 페이지 헤더 컴포넌트
 * - 뒤로가기 버튼
 * - 페이지 타이틀
 */
export function AuthHeader({ onBack }: AuthHeaderProps) {
  const { locale } = useLanguage();
  const t = loginPageTranslations[locale];

  return (
    <div className="bg-primary h-[50px]">
      <div className="flex items-center justify-center relative h-[50px] px-[20px]">
        <button
          onClick={onBack}
          className="absolute left-[20px] flex items-center justify-center w-[32px] h-[32px]"
        >
          <svg className="w-[12px] h-[21px]" fill="none" preserveAspectRatio="none" viewBox="0 0 12 21">
            <path d={svgPaths.p27596280} fill="white" />
          </svg>
        </button>
        <h1
          className={`font-['Noto_Sans:Bold',_'Noto_Sans_KR:Bold',_sans-serif] font-bold text-[16px] text-white tracking-[-0.32px] text-center ${locale !== 'ko' ? 'uppercase' : ''}`}
          style={{ fontVariationSettings: "'CTGR' 0, 'wdth' 100" }}
        >
          {t.title}
        </h1>
      </div>
    </div>
  );
}
